import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { SpinnerService } from '../../../services/spinner.service';
import { ToastService } from '../../../services/toast.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { Router } from '@angular/router';
import { FolhaPagamento } from '../../../models/folhaPagamento.model';
import { FolhaPagamentosService } from '../../../services/folha-pagamentos.service';
import { FormataDataHelper } from '../../../helpers/formata-data.helper';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';

@Component({
    selector: 'app-folha-pagamentos-listagem',
    templateUrl: './folha-pagamentos-listagem.component.html',
    styleUrls: ['./folha-pagamentos-listagem.component.scss'],
    providers: [ConfirmationService]
})
export class FolhaPagamentosListagemComponent implements OnInit {
    @ViewChild('dt') dt: Table | undefined;
    @Output() tituloChange = new EventEmitter<string>();
    @Output() iconeChange = new EventEmitter<string>();

    folhasPagamentos: any;
    usuarioId: string = '';

    constructor(
        private folhaPagamentosService: FolhaPagamentosService,
        private confirmationService: ConfirmationService,
        private spinnerService: SpinnerService,
        private toastService: ToastService,
        private router: Router,
        private jwtHelper: JwtHelper
    ) { }

    ngOnInit(): void {
        this.tituloChange.emit('Listagem de Folha de pagamentos');
        this.iconeChange.emit('pi pi-list');
        this.usuarioId = this.jwtHelper.getUserIdFromToken();
        this.carregaFolhaPagamentos();
    }

    carregaFolhaPagamentos() {
        this.spinnerService.show('Carregando folha de pagamentos...');
        this.folhaPagamentosService.getFolhaPagamentos(this.usuarioId).subscribe({
            next: (res) => {
                this.folhasPagamentos = this.organizaData(res);
                this.spinnerService.hide();
            },
            error: (e) => {
                console.error('Erro ao carregar folha de pagamentos:', e);
                this.toastService.setMensagemToast('Erro ao carregar folha de pagamentos', SeveridadeToast.Error);
                this.spinnerService.hide();
            }
        })
    }

    excluirPagamento(pagamento: any): void {
        this.confirmationService.confirm({
            message: `Tem certeza que deseja deletar este pagamento de ${FormataDataHelper.formatarCompetencia(pagamento.pa)}?`,
            header: 'Confirmar Exclusão',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.spinnerService.show('Excluindo pagamento...');
                this.folhaPagamentosService.deletePagamento(pagamento.id).subscribe({
                    next: () => {
                        this.toastService.setMensagemToast('Pagamento excluído com sucesso.', SeveridadeToast.Success);
                        this.carregaFolhaPagamentos();
                        this.spinnerService.hide();
                    },
                    error: (e) => {
                        console.error('Erro ao excluir pagamento:', e);
                        this.toastService.setMensagemToast(`Erro ao excluir pagamento: ${e.error?.message || 'Erro desconhecido'}`, SeveridadeToast.Error);
                        this.spinnerService.hide();
                    }
                });
            },
        });
    }

    adicionarPagamento(): void {
        this.router.navigate(['folha-pagamentos/adicionar']);
    }

    editarPagamento(pagamento: FolhaPagamento): void {
        this.router.navigate(['folha-pagamentos/editar', pagamento]);
    }

    applyFilterGlobal(event: Event): void {
        const input = event.target as HTMLInputElement;
        const filterValue = input.value;
        if (this.dt) {
            this.dt.filterGlobal(filterValue, 'contains');
        }
    }

    formatCompetencia(pa: number | undefined): string {
        return FormataDataHelper.formatarCompetencia(pa);
    }

    organizaData(data: any): any {
        data = data.sort((paUm, paDois) => paDois.pa - paUm.pa);
        return data;
    }
}
